import React from "react";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import {
    KnowledgeBaseLeftPanel,
    useKnowledgeLibraryContext,
    useNavigation,
    VerticalTabWithPaperContainer
} from "@limitless/portal";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { useExpertProfileContext } from "@limitless/expert";
import KnowledgeArticles from "../knowledge-articles/KnowledgeArticles";

const KnowledgeBase = () => {
    const { selectedLibrary } = useKnowledgeLibraryContext();

    const { navigate } = useNavigation();
    const { isDarkMode } = useExpertProfileContext();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    React.useEffect(() => {
        if (Object.keys(selectedLibrary).length === 0) {
            navigate("/knowledge");
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <VerticalTabWithPaperContainer
                tabContent={<KnowledgeBaseLeftPanel />}
                paperContent={<KnowledgeArticles />}
            />
        </ThemeProvider>
    );
};

export default KnowledgeBase;
